<template>
<div>
    <v-flex xs12 sm12 md12>
        <v-card color="grey lighten-5" flat>
            <v-layout row wrap>
                <v-flex xs11 sm11 md12 pl-3>
                    <v-card color="grey lighten-5" flat class="white--text">
                        <v-card color="grey lighten-5" flat="">
                            <v-card-actions>
                                <v-layout row wrap>
                                    <v-flex xs10 sm10 md10>
                                        <v-autocomplete :disabled="aktifmi" v-on="WatchStarter" :autofocus="autofocuss" @blur="focuslost(val)" :rules="rule" hide-details="" clearable append-icon="search" :label="$t('Consulate-Code')" v-model="val" :loading="loading" :items="stateKonsolosluk" item-text="name" item-value="value" :search-input.sync="search1" cache-items="">
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs2 sm2 md2>
                                        <v-layout align-center="" fill-height="">
                                            <v-btn fab small @click.native="dialogYeniKonsolosluk=true" color="info" icon>
                                                <v-icon>add_box</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <span class="body-1 font-weight-bold grey--text mb-2">
                                            {{ $t('Address_label') }} : {{konsoloslukSonuc.Adres}} </span>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <span class="body-1 font-weight grey--text mb-2">VNo :
                                            {{ konsoloslukSonuc.VNo}} </span>

                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <span class="body-1 font-weight grey--text mb-2"> Tel :
                                            {{konsoloslukSonuc.Tel1}}</span>

                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <span class="body-1 font-weight grey--text mb-2">{{$t('Email_label')}}:
                                            {{konsoloslukSonuc.Email}} </span>

                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <span class="body-1 font-weight grey--text mb-2">Web:
                                            {{konsoloslukSonuc.Web}} </span>

                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-card>
                </v-flex>

            </v-layout>
        </v-card>
    </v-flex>

    <v-dialog v-model="dialogYeniKonsolosluk" scrollable="" persistent="" max-width="400px">
        <v-card color="grey lighten-5">
            <v-card-title>Yeni Konsolosluk Ekle</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row="" wrap="">
                    <v-flex pa-1 xs12 sm6 md12>
                        <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>
                                        <v-form ref="formKonsolosluk" v-model="valid" lazy-validation>
                                            <v-select :items="saticiTipi" hide-details="" v-model="Satici.Ic_Dis" item-text="text" item-value="value" clearable :label="$t('Seller-Type')"></v-select>
                                            <v-text-field :rules="[v => !!v || $t('This-area-mandatory')]" :label="$t('Currentcode_label')" v-model="Satici.Cari_Kod.kod" hide-details="">
                                            </v-text-field>
                                            <v-text-field hide-details="" :rules="[v => !!v || $t('This-area-mandatory')]" label="Kod" v-model="Satici.Kod"></v-text-field>
                                            <v-text-field hide-details="" :rules="[v => !!v || $t('This-area-mandatory')]" label="İsim" v-model="Satici.Isim"></v-text-field>
                                            <v-text-field hide-details="" :label="$t('Phonenumber_label')" v-model="Satici.Tel1"></v-text-field>
                                            <v-text-field hide-details="" :label="$t('Email_label')" v-model="Satici.Email"></v-text-field>
                                            <v-text-field hide-details="" :label="$t('Taxnumber_label')" v-model="Satici.VNo"></v-text-field>
                                            <v-text-field hide-details="" :label="$t('Web-Address')" v-model="Satici.Web"></v-text-field>
                                        </v-form>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogYeniKonsolosluk=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="yeniKonsoloslukKaydet()">{{$t("save_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
    </v-card>
</div>
</template>

<script>
import auth from '../../../../api/auth'
import tool from "../tools";
import helpers from "@/components/app/customcomp/helpers.js"

export default {
    //props: ["value", "tabdeger","stateKonsoloslukYedek", "autofocuss", "aktifmi", "Coper"],
        props: {
        value: {
            type: String
        },
        tabdeger: {
            type: String
        },
        Coper: {
            type: Boolean,
            default: false
        },
        autofocuss: {
            type: Boolean,
            default: false
        },
        stateKonsoloslukYedek: {
            type: Array,
        },
        rules: {
            type: Boolean,
            default: false,
        },
        aktifmi: {
            type: Boolean,
            default: false
        }
    },
    computed: {
                WatchStarter: function () {
            if (this.value != null && this.value != '' && this.value != 'undefined') {
                this.konsoloslukislemler();
            }
        },
        'val': {
            get: function () {
                return this.value;
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        }
    },

    beforeMount: beforeMount,
    filters: {

        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },
        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }

    },

    methods: {
        getparabirimi() {
            return helpers.getparabirimi()
        },
        focuslost(a) {
            if (this.search1 == null) {
                this.val = null
            }
        },
        yeniKonsoloslukKaydet() {
            if (this.$refs.formKonsolosluk.validate()) {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var prm = this.Satici

                tool.http_post(this, "SaticiKayit", prm).then(
                    response => {

                        if (response.body.Status == true) {
                            this.text1 = 'Kayıt edildi'
                            this.snackbar = true
                            var seciliitems = [{
                                name: this.Satici.Kod + '-' + this.Satici.Isim,
                                value: this.Satici.Kod
                            }]

                            this.stateKonsolosluk = seciliitems
                            this.val = this.Satici.Kod;

                            this.konsoloslukislemler();

                            this.dialogYeniKonsolosluk = false;

                        } else {
                            this.text1 = response.body.ErrorList[0]
                            this.snackbar = true
                        }
                    },
                    response => {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                );
            } else {
                this.text1 = this.$t('Please-fill-required-fields')
                this.snackbar = true
            }
        },
        konsoloslukislemler() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'))
            var prm = {
                saticiTipi: 11,
                saticiKodu: this.val
            }
            this.loading = true
            tool.http_post(this, "SaticiList", prm).then(
                response => {
                    this.konsoloslukSonuc.Adres = response.body.SaticiList[0].Adres
                    this.konsoloslukSonuc.VNo = response.body.SaticiList[0].VNo
                    this.konsoloslukSonuc.Tel1 = response.body.SaticiList[0].Tel1
                    this.konsoloslukSonuc.Email = response.body.SaticiList[0].Email
                    this.konsoloslukSonuc.Web = response.body.SaticiList[0].Web
                },
                response => {}
            );
            this.loading = false
        },
        konsoloslukGetir
    },
    data() {
        return {
            saticiTipi: [{
                    text: 'Yurtiçi',
                    value: 0
                },
                {
                    text: 'Yurtdışı',
                    value: 1
                }
            ],
            Satici: {
                SaticiTipi: 11,
                Ref: null,
                SirketNo: null,
                Kod: null,
                Isim: null,
                Cari_Kod: {
                    id: null,
                    kod: null,
                    isim: null
                },
                Adres: null,
                PK: null,
                Ulke: null,
                Sehir: null,
                Yer: null,
                SaticiKonumu: null,
                Yetkili: null,
                Web: null,
                HavaAlani: null,
                VDaire: null,
                VNo: null,
                Tel1: null,
                Tel2: null,
                Fax: null,
                Teleks: null,
                Email: null,
                GSM: null,
                Ic_Dis: '0',
                Aciklamalar: null,
                LocationF: null,
                OdaTanimlari: null,
                OtelOzellikleri: null,
                krdDerece: null,
                krdDakika: null,
                krdSaniye: null,
                krdDereceM: null,
                krdDakikaM: null,
                krdSaniyeM: null,
                Grup: null,
                PasifKayit: false,
                GlobalKod: null,
                ZincirKodu: null,
                CreatedBy: null,
                CreatedDate: null,
                ModifiedBy: null,
                ModifiedDate: null,
                AutoCreate: null,
                stOtel: {
                    Ucretsizler: [],
                    Ucretliler: [],
                    Kategori: null,
                    GenelMudur: null,
                    SatisMuduru: null,
                    MuhasebeMuduru: null,
                    Donem1: null,
                    Donem2: null,
                    BarLokanta: null,
                    KonferansOda: null,
                    OdaKonum: [],
                    MinKisi: null,
                    OpSure: null,
                    Bedava1: null,
                    Bedava2: null,
                    Cocuk1: null,
                    Cocuk2: null,
                    OtelTip: null,
                    AutoCreate: null,
                },
                stArac: {
                    AracTipi: [],
                    Donem1: null,
                    Donem2: null
                },
                stRestaurant: {
                    KisiYaz: 0,
                    KisiKis: 0,
                    MinKisi: 0,
                    Sorumlu1: null,
                    Sorumlu2: null,
                    Sinif: null,
                    Donem1: null,
                    Donem2: null,
                    Menu: [],
                },
                stAcente: {
                    AcenteTipi: null,
                    Sorumlu1: null,
                    Sorumlu2: null,
                    Donem1: null,
                    Donem2: null,
                    Turlar: [],
                    TransferTasima: [],
                    AcenteTip: 0, //0 merkez- 1 tali
                    Kurumsal: false,
                    Parola: null,
                    AnaAcenteKod: {
                        id: null,
                        kod: null,
                        isim: null,
                        tip: null,
                    }
                },
                stRentACar: {
                    AracTipi: [],
                    Donem1: null,
                    Donem2: null,
                    Araclar: []
                },
                stRehber: {
                    Diller: [],
                    Cinsiyet: 0,
                    Sinif: null,
                    Donem1: null,
                    Donem2: null,
                },

                stMuze: {
                    Donem1: null,
                    Donem2: null,
                    AcikGunler: {
                        Pazartesi: false,
                        Sali: false,
                        Carsamba: false,
                        Persembe: false,
                        Cuma: false,
                        Cumartesi: false,
                        Pazar: false
                    },
                    AcikSaat1: null,
                    AcikSaat2: null,
                    AcikSaat3: null,
                },
                stCharter: {
                    Ucaklar: [],
                    Donem1: null,
                    Donem2: null,
                    OpSure: 0,
                    FormNo: null,
                    HY_Kodu: null,
                    Parkur: [],
                },
                stGemi: {
                    Ucretsizler: [],
                    Ucretliler: [],
                    Kategori: null,
                    GenelMudur: null,
                    SatisMuduru: null,
                    MuhasebeMuduru: null,
                    Donem1: null,
                    Donem2: null,
                    BarLokanta: null,
                    KonferansOda: null,
                    OdaKonum: [],
                    MinKisi: null,
                    OpSure: null,
                    Bedava1: null,
                    Bedava2: null,
                    Cocuk1: null,
                    Cocuk2: null,
                    OtelTip: null,
                    AutoCreate: null,
                },
                stDiger: {
                    Donem1: null,
                    Donem2: null,
                    Aktivite: [],
                },
                stTurOperatoru: {
                    FatPara: null,
                    Donem1: null,
                    Donem2: null
                },
                stKonsolosluk: {
                    Saat1: null,
                    Saat2: null,
                    Gerekliler: null,
                    VizeTip: 0
                },
                stSigorta: null,
                stFeribot: {
                    TurOperatoru: {
                        id: null,
                        kod: null,
                        isim: null,
                        tip: null
                    }
                },
                stGolf: {
                    OtelKod: {
                        id: null,
                        kod: null,
                        isim: null,
                        tip: null
                    }
                }
            },
            bakiye: 0,
            valid: true,
            konsoloslukSonuc: {
                Adres: null,
                VNo: null,
                Tel1: null,
                Email: null,
                Web: null
            },
            dialogYeniKonsolosluk: false,
            stateKonsolosluk: [],
            itemsKonsolosluk: [],
            search1: null,
            loading: false,
            progress: false,
            items: [],
            rule:[],
            dialog: false,
            text1: null,
            loading: false,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
        }
    },

    watch: {
        search1(val) {
            val && this.konsoloslukGetir(val)
        },

        dialog(val2) {
            if (!val2) return
            requestAnimationFrame(() => {
                this.$refs.ara.focus()
            })
        },
        stateKonsoloslukYedek: function (vall) {
            this.stateKonsolosluk = this.stateKonsoloslukYedek
        }
    },
}

function konsoloslukGetir(v) {
    this.stateKonsolosluk = []
    this.itemsKonsolosluk = []
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var konsolosItems = []
    if (v.length >= 0) {
        var prm = {
            saticiTipi: 11,
            saticiKodu: null,
            sqlLike: v,
            limit: 100
        }
        this.loading = true
        setTimeout(() => {
            tool.http_post(this, "SaticiList", prm).then(
                response => {
                    this.itemsKonsolosluk = response.body.SaticiList
                    for (var i = 0; i < this.itemsKonsolosluk.length; i++) {
                        this.stateKonsolosluk.push({
                            name: this.itemsKonsolosluk[i].Isim + " - " + this.itemsKonsolosluk[i].Kod,
                            value: this.itemsKonsolosluk[i].Kod,
                        })
                    }
                },
                response => {}
            );
            this.loading = false
        }, 500)
    } else {
        this.val = null
    }
}

function beforeMount() {

    if (this.stateKonsoloslukYedek != 'undefined' && this.stateKonsoloslukYedek != null && this.stateKonsoloslukYedek != '') {
        this.stateKonsolosluk = this.stateKonsoloslukYedek
    }
        if (this.rules === true) {
        this.rule = [v => !!v || this.$t('Please-select-insurance')]
    }
}
</script>

<style>
.outer {

    position: relative;
    display: inline-block;
    margin: 0 10px;
    padding-top: inherit+100px;

}

.inner {
    position: absolute;
    top: 104%;
    left: 50%;
    padding-block-start: 30px;
    padding-block-end: 10px;
}

.icorta {
    margin: 0px auto;
    height: 226px;
    color: #fff;
    position: absolute;
    left: 92%;
    top: 95%;
    margin-left: -110px;
    margin-top: -15px;
}

.rotate {
    -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);

}
</style>
